import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf26.png';

const MarketShareStep12 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    hideAlert={true}
    subTitle="Research &amp; Investigate"
    paragraph2={(
      <Fragment>
        Given your product's visibility in relation to your competitors, we highly
        recommend that you conduct further Research and revisit the business case
        to evaluate optimal promotion spend for each product.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep12;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step12.js